import { AddProposalModalProps } from './AddProposalModal';
import { openModal } from '@core/components/ModalStack';

export async function openAddProposalModal(props: AddProposalModalProps) {
  const { AddProposalModal } = await import('./AddProposalModal');

  openModal(AddProposalModal, props);
}
